import { format, formatDistanceToNowStrict, isToday, isYesterday, isTomorrow } from 'date-fns'
import { de, enUS } from 'date-fns/locale'
import { TOAST_DURATION, days, localeMap } from '../constants/Constants'
import i18n from '../i18n'
import '../styles/Utils.css'
import { ReactComponent as ToastBell } from '../svg/normalSvgs/toastBell.svg'
import toast from 'react-hot-toast'
import Clock from '../components/Clock'
const date_format = 'dd/MM/yyyy'

const locales = {
    en: enUS,
    de: de,
}

export const notify = ({ message, backgroundColor = '#fddf6d', color = '#5e639b' }) => {
    // toast.custom((t) => {
    // 	t.duration = TOAST_DURATION;
    // 	return (
    // 		<div
    // 			className='notify-custom-container'
    // 			style={{ background: backgroundColor, zIndex: 100 }}
    // 			onClick={() => {
    // 				toast.remove(t.id);
    // 			}}
    // 		>
    // 			<div className='notify-bell-container' style={{ background: color }}>
    // 				<ToastBell style={{ color: backgroundColor }} />
    // 			</div>
    // 			<div className='notify-text-style' style={{ color: color }}>
    // 				<div className='notify-text-title'>{message}</div>
    // 				<div className='notify-text-subtitle'>
    // 					{i18n.t('This popup will be auto closed in')}{' '}
    // 					<span className='notify-text-time'>
    // 						<Clock closeToast={() => toast.remove(t.id)} />
    // 					</span>
    // 				</div>
    // 			</div>
    // 			<div className='notify-close-button' style={{ background: color, color: backgroundColor }}>
    // 				{i18n.t('close')}
    // 			</div>
    // 		</div>
    // 	);
    // });
}

export const format_day = (date, hours = true, locale = 'en') => {
    try {
        const format_locale = locales[locale]
        const formatted_date = formatDistanceToNowStrict(date, { includeSeconds: true, addSuffix: 'ago', unit: 'day' })
        const duration = formatted_date.split(' ')[0]

        if (isToday(date)) {
            return `${i18n.t('today')} ${hours ? format(date, ' HH:mm') : ''}`
        } else if (isTomorrow(date)) {
            return `${i18n.t('tomorrow')} ${hours ? format(date, ' HH:mm') : ''}`
        } else if (isYesterday(date)) {
            return `${i18n.t('yesterday')} ${hours ? format(date, ' HH:mm') : ''}`
        } else if (duration > 6) {
            return format(date, date_format + (hours ? ' HH:mm' : ''), { locale: format_locale })
        } else {
            const day = new Date(date).getDay()
            return `${i18n.t(days[day].toLowerCase())}${hours ? format(date, ' HH:mm') : ''}`
        }
    } catch {
        return ''
    }
}

export const datesAreOnSameDay = (first, second) => {
    return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate()
}

export const checkTextStrength = (text) => !!text.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[.!@#$%^&*]).{8,}/)?.length

export const generate_id = () => {
    const date = Date.now()
    return `_${date.toString(25)}${Math.random().toString(36).substr(2, 33)}`
}

export const format_day_only = (date) => {
    try {
        const formatted_date = formatDistanceToNowStrict(date, { includeSeconds: true, addSuffix: 'ago', unit: 'day' })
        const duration = formatted_date.split(' ')[0]
        if (isToday(date)) {
            return i18n.t('today')
        } else if (isTomorrow(date)) {
            return i18n.t('tomorrow')
        } else if (isYesterday(date)) {
            return i18n.t('yesterday')
        } else if (duration > 6) {
            return format(date, 'dd MMM yyyy', { locale: localeMap[i18n.language] })
        } else {
            const day = new Date(date).getDay()
            return `${i18n.t(days[day].toLowerCase())}`
        }
    } catch (e) {
        return ''
    }
}

export const calcReadingTime = (text) => {
    const wordsPerMinute = 200
    const noOfWords = text.split(/\s/g).length
    return Math.ceil(noOfWords / wordsPerMinute)
}

export const milisToMinutesOrSeconds = (millis) => {
    const mins = Math.floor(millis / 60000)
    return mins > 0 ? `${mins} min` : `${Math.floor(millis / 1000)} ${i18n.t('sec')}`
}

export const pluralize = (text, count) => (count > 1 ? `${text}s` : text)

export const milisToMiliseconds = (millis) => {
    if (!millis) return '0:00'

    let minutes = Math.floor(millis / 60000)
    let seconds = Math.floor((millis % 60000) / 1000).toFixed(0)
    return seconds === 60 ? minutes + 1 + ':00' : minutes + ':' + (seconds < 10 ? '0' : '') + seconds
}

export const mmSSFormat = (timeInSec) => new Date(timeInSec * 1000).toISOString().substr(14, 5)

export const isJson = (str) => {
    try {
        JSON.parse(str)
    } catch (e) {
        return false
    }
    return true
}

export const tryToJson = (str) => {
    try {
        return JSON.parse(str)
    } catch (e) {
        return str
    }
}
export const translateTargetText = (text) => {
    let mapper = {
        years: i18n.t('years').toLowerCase(),
        classes: i18n.t('classes').toLowerCase(),
        Classes: i18n.t('classes'),
        Class: i18n.t('class'),
        Years: i18n.t('years'),
        Year: i18n.t('year'),
        'All students': i18n.t('allStudents'),
        Staff: i18n.t('staff'),
        Custom: i18n.t('custom'),
    }

    return (
        text?.replace(/years|Years|Year|All students|Staff|classes|Classes|Class|Custom/, function (matched) {
            return mapper[matched]
        }) ?? ''
    )
}

export const truncate = (text, startNum = 0, endNum) => {
    if (text.length > endNum) {
        return {
            text: text.substring(startNum, endNum).concat('...'),
            isTruncated: true,
        }
    } else {
        return { text: text, isTruncated: false }
    }
}
export const makeArray = (size, element) => {
    let arr = []
    for (let i = 0; i < size; i++) arr.push(element)
    return arr
}

export const formatTwoDigitNumber = (number) => (number > 9 ? number : `0${number}`)
export const getPercentage = (a, b) => {
    return Math.round((a / b) * 100)
}

export const formatDayCode = (date) => `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`

export const sumArray = (arr) => arr?.reduce((partialSum, a) => partialSum + a, 0)

export const translateSuccessLanguage = (language) => {
    switch (language) {
        case 'en':
            return 'Language is changed'
        case 'de':
            return 'Sprache wurde geändert'
        case 'es':
            return 'Se ha cambiado el idioma'
        default:
            return 'Language is changed'
    }
}
